import { z } from "zod";

/** The code-owned behaviors a task type can carry; task-catalog defines what each one does. */
export const SystemTaskKeySchema = z
  .enum([
    "review_case_creation",
    "provide_case_documents",
    "review_case_exception",
    "review_missing_payment_receipt",
    "analyze_case_liability",
    "analyze_debt_case",
    "search_dvc",
    "update_third_party_contact",
    "request_additional_documents",
  ])
  .describe("Code-owned behavior of a task type; never set by admins");
export type SystemTaskKey = z.infer<typeof SystemTaskKeySchema>;
